<div class="cancel-container wd-100 p-b-24">
  <div class="dialog-header flex_sb p-16">
    <div class="fs-23 fw-600">
      {{ 'SHARED.CANCEL_PAYMENT' | fallbackTranslate }}
    </div>
    <div class="dialog-header-cross flex-center" (click)="cancelClicked()">
      <img [src]="images.CROSS" class="img-20" alt="close" />
    </div>
  </div>
  <div class="clr-666 m-t-40 flex-center fs-16 fw-400 p-l-25  p-r-25">
        {{ 'SHARED.CANCEL_TEXT' | fallbackTranslate }}
  </div>
  <div class="flex_sb flex_row m-t-15 p-l-25 p-r-25">
    <div *ngIf="!isLoading" class="btn-cls m-t-22 flex-center fw-600 yes-cancel" nzType="primary" nzGhost  (click)="!isLoading?cancelPayment():''">
      {{ 'SHARED.CANCEL_BTN' | fallbackTranslate }}
    </div>
    <div *ngIf="isLoading" class="btn-cls m-t-22 flex-center fw-600 yes-cancel" nzType="primary" nzGhost >
      <i nz-icon nzType="loading"></i>
    </div>
    <div class="btn-cls m-t-22 flex-center fs-16 fw-600 no-continue" nzType="primary" (click)="cancelClicked()" >
      {{ 'SHARED.CONTINUE_BTN' | fallbackTranslate }}
    </div>
  </div>
</div>
